import { atom } from "recoil";

const textTypeOptions = [
	{ value: "local", label: "local" },
	{ value: "international", label: "international" },
];
const descriptionTypeOptions = [
	{ value: "international", label: "international" },
	{ value: "mixed", label: "mixed" },
];
const rtpLabelTypeOptions = [{ value: "international", label: "international" }];

const createInitialValues = () => ({
	poster: "",
	name: "",
	nameType: null,
	description: "",
	descriptionType: null,
	rtp: "",
	rtpLabelText: "",
	rtpLabelType: { ...rtpLabelTypeOptions[0] },
	categoryID: [],
	providerName: "",
	providerLink: "",
});

const initialScenarioState = {
	cohortConditions: [],
	messages: [""],
};

const initialTriggerEditorScenarioState = {
	cohortGroups: [],
	newConditionByGroupId: {},
};

export const gamesSweepstakesModalStore = atom({
	key: "gamesSweepstakesModalStore",
	default: {
		show: false,
		loaded: true,
		activeTab: "game",
		values: createInitialValues(),
		triggerValues: {
			lessThanTicket: initialScenarioState,
			ticketToDouble: initialScenarioState,
		},
		triggerEditor: {
			activeScenarioTab: "lessThanTicket",
			lessThanTicket: initialTriggerEditorScenarioState,
			ticketToDouble: initialTriggerEditorScenarioState,
		},
		currentOption: {
			nameType: textTypeOptions,
			descriptionType: descriptionTypeOptions,
			rtpLabelType: rtpLabelTypeOptions,
		},
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
